export default "__VITE_ASSET__BAI4rRVf__"